module.exports = __webpack_public_path__ + "img/logo.9c3673d8.png";